module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "konfigurator-hmotnostkondice"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm._f("translate")('Enter the current weight')))]), _vm._v(" "), _c('span', {
    class: {
      'is-refreshed': _vm.refreshWeight
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((!_vm.isValidHmotnost() || !_vm.isKondiceValid()) && this.tryescape),
      expression: "(!isValidHmotnost() || !isKondiceValid()) && this.tryescape"
    }],
    staticClass: "info-messages-box"
  }, [(!_vm.isValidHmotnost() && this.tryescape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")("You have to choose your pet's weight")) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isKondiceValid() && this.tryescape) ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")("You have to choose your pet's fitness")) + "\n        ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-content",
    class: {
      'has-error': !_vm.isValidHmotnost() && this.tryescape, 'has-success': _vm.isValidHmotnost() && this.tryescape
    }
  }, [_c('div', {
    staticClass: "input-blok input-vaha"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.petWeight),
      expression: "petWeight"
    }],
    staticClass: "form-control form-control-vaha",
    attrs: {
      "type": "number",
      "placeholder": _vm._f("translate")('Enter the weight of your pet'),
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.petWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.petWeight = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-type-select select-jednotky"
  }, [_c('div', {
    staticClass: "select-content"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mazlicek.hmotnostkondice.hmotnostJednostka),
      expression: "mazlicek.hmotnostkondice.hmotnostJednostka"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.mazlicek.hmotnostkondice, "hmotnostJednostka", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "kg"
    }
  }, [_vm._v("kg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lb"
    }
  }, [_vm._v("lb")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mazlicek.jeStene && !this.checkPrumHmotnost),
      expression: "!mazlicek.jeStene && !this.checkPrumHmotnost"
    }],
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("translate")('Are you sure about the weight of your pet?')))])]), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('div', {
    staticClass: "hmotnost-kondice-title"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Determine honestly how fit it is now')) + "\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('div', {
    staticClass: "form-radios",
    class: {
      'has-error': !_vm.isKondiceValid() && this.tryescape
    }
  }, _vm._l((_vm.kondiceItems), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "form-type-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.mazlicek.hmotnostkondice.kondice),
        expression: "mazlicek.hmotnostkondice.kondice"
      }],
      attrs: {
        "type": "radio",
        "id": item.id,
        "placeholder": _vm._f("translate")('Enter current weight')
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.mazlicek.hmotnostkondice.kondice, item.id)
      },
      on: {
        "change": function($event) {
          _vm.$set(_vm.mazlicek.hmotnostkondice, "kondice", item.id)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": item.id
      }
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.description.length > 0) ? _c('div', {
      staticClass: "item-desc",
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    }) : _vm._e()])])
  })) : _c('div', {
    staticClass: "infobox"
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")("For an adult dog, you select what current condition it is in. For puppies, this is not relevant for the calculation of Haffit. Choose the 'Continue' button.")) + "\n        ")])]), _vm._v(" "), (!_vm.mazlicek.jeStene) ? _c('info', {
    attrs: {
      "krok": 6
    }
  }) : _vm._e(), _vm._v(" "), _c('navigace', {
    attrs: {
      "showPrev": true,
      "onClickPrev": _vm.prev,
      "showNext": true,
      "onClickNext": _vm.next,
      "onClickSaveAndQuit": _vm.saveAndQuit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e0729ee6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/06HmotnostKondice.vue
// module id = 556
// module chunks = 1